<template lang="pug">
    .service-type-selector
        html-capable-select-box(
            :options="serviceTypeOptions",
            :showSearch="false",
            v-bind:value="value",
            @input="onInput",
        )
</template>

<script>
    import $ from 'jquery';
    import HtmlCapableSelectBox from './HtmlCapableSelectBox.vue';

    export default {
        components: { HtmlCapableSelectBox },
        props: {
            serviceTypes: {
                type: Array,
                required: true,
            },
            value: {
                type: String,
                required: false,
            },
        },
        computed: {
            serviceTypeOptions() {
                return this.serviceTypes.map(st => ({
                    value: st.slug,
                    html: this.optionTemplate(st),
                }));
            },
        },
        methods: {
            optionTemplate(st) {
                return `<div class="service-type-selector-option">
                            <div><span class="rover-icon rover-icon-lg rover-icon-${st.icon}"></span></div>
                            <div>
                                <a href="${st.seo_url || '#'}">
                                    <div class="service-type-selector-name">${st.name}</div>
                                    <div class="service-type-selector-description">${st.description}</div>
                                </a>
                            </div>
                        </div>`;
            },
            onInput(serviceType) {
                this.$emit('input', serviceType);
            },
        },
        mounted() {
            this.$nextTick(() => {
                $('.service-type-selector-option a').on('click', (e) => {
                    e.preventDefault();
                });

                // If it's iPad, handle touch event in the same way click would have been normally handled
                if (Rover.utils.isiOS()) {
                    $('.service-type-selector .select2').on('touchstart', (e) => {
                        if ($('.service-type-selector .select2').hasClass('select2-container--open')) {
                            $('.service-type-selector .form-control').select2('close');
                        }
                        else {
                            $('.service-type-selector .form-control').select2('open');
                        }

                        // HTML for select2 seems to be destroyed and recreated every time so need to rebind this event
                        $('.service-type-selector-option').parent('.select2-results__option').on('touchstart', (e) => {
                            // Correlate new value based on the position index in the list
                            const current_index = $(e.currentTarget).index();
                            const new_value = $('.service-type-selector .form-control option')[current_index].value;

                            // Update dropdown value and close it
                            $('.service-type-selector .form-control').val(new_value).trigger('change');
                            $('.service-type-selector .form-control').select2('close');
                        });

                        e.preventDefault();
                    });
                }
            });
        },
    };
</script>

<style lang="scss">
    @import '../../../css/utilities/mixins';

    .service-type-selector-option {
        display: flex;

        .rover-icon.rover-icon-lg {
            margin: 5px 16px 5px 10px;
            font-size: 24px;
            color: $primary-1;
        }
        a:hover {
          text-decoration: none;
        }
    }
    .service-type-selector-name {
        color: $text-color;
        font-size: 16px;
        line-height: 1.2;
    }
    .service-type-selector-description {
        @include small-text;
        @include text-muted;
        line-height: 1.2;
    }

    .service-type-selector {
        .select2-container {
            max-width: 100%;

            .select2-selection .select2-selection__rendered {
                padding-left: 0;
            }
            .select2-selection--single {
                height: 45px;
                padding: 5px;
                border-color: $gray-1;
                .select2-selection__arrow {
                    width: auto;
                    height: auto;
                    padding: 22px;
                    background-color: $primary-1;
                    b { border-color: $white transparent transparent transparent; }
                }
            }
            &.select2-container--open .select2-selection--single .select2-selection__arrow b {
                border-color: transparent transparent $white transparent;
            }
        }
    }

    // Needs to be outside the .service-type-selector selector since the dropdown is assembled
    // in an element at the end of <body> and attached to the "select" box via JS.
    .select2-container {
        .select2-dropdown {
            border-color: $gray-1;
            box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.2);

            .select2-results .select2-results__options {
                max-height: none;

                .select2-results__option--highlighted {
                    background-color: $gray-0;
                }

                .select2-results__option[aria-selected=true] {
                    background-color: $gray-0;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// ServiceTypeSelector.vue?1cfe588e